import { IconProgressCheck, IconRefreshDot } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../components/DataTable/TableComponent';
import DropDown from '../../components/DropDown/DropDown';
import SearchComponent from '../../components/Search/SearchComponent';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { dateTimeConverter, getDaysLeft } from '../../utils/dateTimeConverter';

const PlanPurchasedList = () => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    const [searchData, setSearchData] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);

    const statusList = [
        {
            id: null,
            name: "All",
            color: "primary"
        }, {
            id: "FREE",
            name: "Free",
            color: "warning"
        }, {
            id: "BASIC",
            name: "Basic",
            color: "success"
        }, {
            id: "PROFESSIONAL",
            name: "Professional",
            color: "danger"
        }, {
            id: "ENTERPRISE",
            name: "Enterprise",
            color: "danger"
        }]

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function getList() {
        loadingShow();
        let statusFilterLocal = statusList?.find(item => item?.name == statusFilter);
        let url = `${urlApi.getLiveChatPurchasedList}?page=${activePage}&limit=${perPage}`;
        if (searchData) {
            url += `&search=${searchData}`
        }
        if (statusFilterLocal?.id) {
            url += `&filterByPlan=${statusFilterLocal ? statusFilterLocal?.id : null}`
        }
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        // if (accessCheck(accessKeys.getUserList)) {
        getList();
        // }
    }, [activePage, perPage, searchData, statusFilter])


    function onStatusFilterChange(status) {
        setActivePage(1);
        setStatusFilter(status)
    }

    function resetAll() {
        setActivePage(1);
        setPerPage(10);
        setSearchData(null);
        setStatusFilter(null);
        document.getElementById("user-table-search").value = ""
    }

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "User", center: "true", grow: 1, selector: (row) => row?.category, cell: (row) => (
                <Link to={'/user/' + row?.userId} className="text-center flex gap-2 items-center py-2">
                    <img src={row?.userProfilePic} alt="" className='h-8 rounded-full aspect-square object-cover bg-slate-500 mx-auto' />
                    <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{row?.userName}</p>
                </Link>
            )
        }, {
            name: "Contact", center: "true", grow: 1, selector: (row) => row?.category, cell: (row) => (
                <div className='my-1'>
                    <p className="mb-2 text-sm text-[var(--black)]">{row?.userEmail}</p>
                    <p className="text-sm text-[var(--black)]">{row?.userPhone}</p>
                </div>
            )
        }, {
            name: "Organization", center: "true", grow: 1, selector: (row) => row?.category, cell: (row) => (
                <p className="mb-2 text-sm text-[var(--black)]">{row?.organizationName}</p>
            )
        }, {
            name: "Plan Details", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <div className='py-2'>
                    <Badge className='mb-2' bg={row?.planPrice == 0 ? 'warning' : 'success'}>{row?.planName}</Badge>
                    {row?.planPrice != 0 && <p className='mb-1'>Price : {row?.planPrice}/mo </p>}
                    {row?.planPrice != 0 && <p className='mb-1'>Paid : {row?.amountPaid} </p>}
                    <p className=''>Operator : {row?.operatorCount || 1} </p>
                </div>
        }, {
            name: "Duration", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <div>
                    <p className='mb-2'>{dateTimeConverter(row?.planStartDate)} - {dateTimeConverter(row?.planEndDate)}</p>
                    <p className='font-semibold'>[ {row?.planDuration} Months ]</p>
                    <p>{getDaysLeft(row?.planEndDate)} day(s) left</p>
                </div>
        }
    ];
    return (
        <Layout>
            <div className='flex items-center mb-3 justify-between'>
                <h1 className='text-xl font-bold text-gray-600'>Live Chat Purchased List</h1>
            </div>

            {/* {accessCheck(accessKeys.getUserList) && */}
            <div className='flex mb-3 justify-between items-center flex-wrap gap-2'>
                <SearchComponent onClear={() => { document.getElementById("user-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("user-table-search")?.value); setActivePage(1) }} inputId='user-table-search' placeholder={"Search..."} />
                <div className='ms-auto'>
                    <DropDown title={"Plan Types"} list={statusList?.map(item => item?.name)} defaultValue={statusFilter} onSelect={(name) => onStatusFilterChange(name)} />
                </div>
                <div className='ms-[auto] md:ms-0'>
                    <IconRefreshDot className='cursor-pointer text-[var(--secondary-gradient-1)]' onClick={() => resetAll()} />
                </div>
            </div>
            {/* } */}
            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={true}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />
        </Layout>
    )
}

export default PlanPurchasedList